import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/layout/Logo";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const next = localStorage.getItem("forja_next") || "/dashboard";
    localStorage.removeItem("forja_next");
    api
      .post("/auth/session", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(next, { replace: true, state: { user: data } });
      })
      .catch(() => navigate("/?auth=error", { replace: true }));
  }, [location.hash, navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#050505]" data-testid="auth-callback">
      <div className="flex flex-col items-start gap-4">
        <Logo />
        <p className="text-sm text-zinc-400">Verificando tu sesión<span className="cursor-block" /></p>
      </div>
    </div>
  );
}
